/**
 * Hijri display helpers. Hijri values are resolved server-side from the organization's
 * authority table (hijri_authority, i18n doc §5.2) — never from Intl islamic calendars.
 */
export interface HijriParts {
  day: number;
  /** 1 = Muharram … 12 = Dhu al-Hijjah */
  month: number;
  year: number;
  /** Month not yet confirmed by the authority → render with "≈" and an explanation. */
  tentative: boolean;
}

export const HIJRI_MONTHS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] as const;
export type HijriMonth = (typeof HIJRI_MONTHS)[number];

export function isHijriMonth(value: number): value is HijriMonth {
  return Number.isInteger(value) && value >= 1 && value <= 12;
}

